module.exports = __webpack_public_path__ + "houseWithMoreHills-3EBQUBg.png";